import React, { FC } from 'react'
import { FaqSection } from '../FaqModule'

import styles from './FaqFilter.module.scss'

type FaqFilterProps = {
  sections: FaqSection[]
}

const FaqFilter: FC<FaqFilterProps> = ({ sections }) => {
  return (
    <div className={styles.outerContainer}>
      <div className={styles.container}>
        {sections &&
          sections.map((section) => (
            <div className={styles.item} key={section.title}>
              <a className="linkHover bodyText" href={`#${section.title}`}>
                {section.title}
              </a>
            </div>
          ))}
      </div>
    </div>
  )
}

export default FaqFilter
